export default __webpack_public_path__ + "static/media/Hand_left.e37cfb88.svg";